import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import SeminarCard from "./seminarCards/SeminarCard";
import { motion } from "framer-motion";
import { client } from "../client";

const Seminars = ({ setSingleSeminar }) => {
  const [seminars, setSeminars] = useState([]);

  useEffect(() => {
    client.fetch(`*[_type == "seminars"]`).then((res) => setSeminars(res));
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 10000,
    slidesToShow: 1,
    slidesToScroll: 1,

    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  };
  return (
    <motion.div
      id="seminars"
      whileInView={{ y: [50, 0], opacity: [0, 1] }}
      transition={{ duration: 0.5 }}
    >
      <h1 className="secTitle">Our Seminars</h1>
      <p className="secDesc">
        Lorem, ipsum dolor sit amet consectetur adipisicing elit.
      </p>
      <Slider {...settings} className="slider">
        {seminars.map((seminar, i) => {
          return (
            <div key={i}>
              <SeminarCard
                seminar={seminar}
                setSingleSeminar={setSingleSeminar}
              />
            </div>
          );
        })}
      </Slider>
    </motion.div>
  );
};

export default Seminars;
